
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mpcklbtjuvsafsrltxpi.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1wY2tsYnRqdXZzYWZzcmx0eHBpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1NzI1NDAsImV4cCI6MjA3MDE0ODU0MH0.ApB8RXC9_fJyVMa-_7x3279g5ZPZ9YOhtYx4mgXf4ww'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
